import { create } from 'jss';
import { jssPreset } from '@material-ui/styles';

/**
 * Ancora todas as folhas de estilo JSS (MUI v4) num ponto fixo do <head>
 * (comentário `jss-insertion-point` em public/index.html). Sem isso, o JSS
 * desanexa e reanexa suas folhas no fim do <head> a cada mount/unmount da
 * árvore que as usa, invertendo a ordem de cascata em relação a overrides do
 * styled-components sempre que uma navegação desmonta e remonta o layout
 * (ex.: ida e volta para /prototipo).
 */
export default create({
  ...jssPreset(),
  insertionPoint: 'jss-insertion-point',
});
